<template>
    <div>
        <limitless-page-header
            :sub-title="'Massuppdatering' + (mode === 'price' ? ' priser' : (mode === 'stock' ? ' lagersaldo' : ''))"
        >
            <template #header-elements>
                <limitless-page-header-button v-if="mode === 'stock' && hasPermission('red_stocktaking')" url="/product/stock/historic" icon="icon-history">Saldohistorik</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable
                :url="'/vue/products?mode=' + this.mode + 'update'"
                :columns="table_columns"
                :filter="table_filter"
                size="xs"
                :per-page="per_page"
                sort-by="ProdID"
                sort-order="asc"
                :row-class="getRowClass"
                ref="prodtable"
                hide-per-page
            >
                <div class="row">
                    <div class="col-auto" style="width: 250px;">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                    <div class="col-auto" style="width: 200px;">
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="chk-show-all" v-model="table_filter.is_phased_out" :true-value="null" :false-value="0">
                            <label class="custom-control-label" for="chk-show-all">Visa alla produkter</label>
                        </div>
                    </div>
                    <div class="col-auto" style="width: 200px;">
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="chk-show-changes" v-model="show_changes">
                            <label class="custom-control-label" for="chk-show-changes">Visa endast ändringar</label>
                        </div>
                    </div>
                    <div class="col-auto" style="width: 200px; margin-left: auto;">
                        <v-select
                            v-model="per_page"
                            :reduce="(opt) => opt.id"
                            :options="[{ id: 25, label: '25 per sida' },{ id: 100, label: '100 per sida' },{ id: 250, label: '250 per sida' },{ id: 10000, label: 'Alla' }]"
                            :clearable="false"
                        ></v-select>
                    </div>
                    <div class="col-auto" style="width: 150px;">
                        <limitless-button ref="btnsave" :busy="busy_saving" icon="icon-floppy-disk" class="btn-block" @click.prevent="multiUpdate">SPARA</limitless-button>
                    </div>
                </div>
                <template #cell_ProdID="{ row }">
                    <router-link :to="{ name: 'products.edit', params: { id:  row.ProdID } }">{{ row.ProdID }}</router-link><MarkedProductIndicator :prod-id="row.ProdID" />
                </template>
                <template #cell_images="{ row }">
                    <div v-if="row.images && row.images.length > 0">
                        <img :id="`product-image-${row.ProdID}`" :src="row.images[0].urls['small']" :alt="row.ProdID" style="height: 60px; margin: -8px 0;">
                        <!--                    <div v-if="row.images.length > 1" style="margin-top: 8px; margin-bottom: -8px;">{{ row.images.length }} bilder i popup</div>-->
                        <b-popover :target="`product-image-${row.ProdID}`" triggers="hover">
                            <img :src="row.images[0].urls['medium']" :alt="row.ProdID" style="width: 100%;">
                        </b-popover>
                    </div>
                </template>
                <template #cell_isPhasedOut="{ row }">
                    <div v-if="row.isStruct" class="badge badge-info">STRUKTURARTIKEL</div>
                    <div v-if="row.isHiddenFromAllCards" class="badge badge-purple">GÖMD FRÅN KORT</div>
                    <div v-else-if="row.show_on_all_cards" class="badge badge-warning">VISAS PÅ ALLA KORT</div>
                    <div v-if="row.isPhasedOut === 1" class="badge badge-danger">HAR UTGÅTT</div>
                    <div v-else>
                        <div v-if="row.isNonStockItem" class="badge badge-warning">Beställningsvara</div>
                        <div v-if="row.isOutOfStock === 1">
                            <div class="badge badge-danger">TILLF. SLUT</div>
                            <div v-if="row.BackInStockDate">Åter {{ row.BackInStockDate }}</div>
                            <div v-else-if="row.no_refill" class="badge badge-purple">EJ REFILL</div>
                            <div v-else-if="row.autoblockfunction === 'isPhasedOut'" class="badge badge-warning">UTGÅENDE</div>
                        </div>
                        <div v-else-if="row.no_refill" class="badge badge-purple">EJ REFILL</div>
                        <div v-else-if="row.autoblockfunction === 'isPhasedOut'" class="badge badge-warning">UTGÅENDE</div>
                    </div>
                </template>
                <template #cell_new_stock="{ row }">
                    <input type="number" class="form-control"
                           :value="(products[row.ProdID] && products[row.ProdID].stock ? products[row.ProdID].stock : '')" @input="setValue(row.ProdID, 'stock', $event)">
                </template>
                <template #cell_new_prod_net_price="{ row }">
                    <input type="number" class="form-control" :placeholder="row.ProdNetPrice"
                           :value="(products[row.ProdID] && products[row.ProdID].prod_net_price ? products[row.ProdID].prod_net_price : '')" @input="setValue(row.ProdID, 'prod_net_price', $event)">
                </template>
                <template #cell_new_pack_price="{ row }">
                    <input type="number" class="form-control" :placeholder="row.PackPrice"
                           :value="(products[row.ProdID] && products[row.ProdID].pack_price ? products[row.ProdID].pack_price : '')" @input="setValue(row.ProdID, 'pack_price', $event)">
                </template>
                <template #cell_new_pack_mtrl_price="{ row }">
                    <input type="number" class="form-control" :placeholder="row.PackMtrlPrice"
                           :value="(products[row.ProdID] && products[row.ProdID].pack_mtrl_price ? products[row.ProdID].pack_mtrl_price : '')" @input="setValue(row.ProdID, 'pack_mtrl_price', $event)">
                </template>
                <template #cell_new_freight_price="{ row }">
                    <input type="number" class="form-control" :placeholder="row.FreightPrice"
                           :value="(products[row.ProdID] && products[row.ProdID].freight_price ? products[row.ProdID].freight_price : '')" @input="setValue(row.ProdID, 'freight_price', $event)">
                </template>
                <template #cell_new_direct_sales_price="{ row }">
                    <input type="number" class="form-control" :placeholder="row.ProdDirectSalesPrice"
                           :value="(products[row.ProdID] && products[row.ProdID].direct_sales_price ? products[row.ProdID].direct_sales_price : '')" @input="setValue(row.ProdID, 'direct_sales_price', $event)">
                </template>
                <template #cell_new_staff_price="{ row }">
                    <input type="number" class="form-control" :placeholder="row.StaffPrice"
                           :value="(products[row.ProdID] && products[row.ProdID].staff_price ? products[row.ProdID].staff_price : '')" @input="setValue(row.ProdID, 'staff_price', $event)">
                </template>
                <template #cell_new_prod_vat="{ row }">
                    <select class="form-control" @change="setValue(row.ProdID, 'prod_vat', $event)"
                            :value="(products[row.ProdID] && products[row.ProdID].prod_vat ? products[row.ProdID].prod_vat : row.ProdVAT)">
                        <option value="0">0 %</option>
                        <option value="6">6 %</option>
                        <option value="12">12 %</option>
                        <option value="25">25 %</option>
                    </select>
<!--                    <input type="number" class="form-control" :placeholder="row.ProdVAT"-->
<!--                           :value="(products[row.ProdID] && products[row.ProdID].new_prod_vat ? products[row.ProdID].new_prod_vat : '')" @input="setValue(row.ProdID, 'new_prod_vat', $event)">-->
                </template>
                <template #cell_new_account="{ row }">
                    <input type="number" class="form-control"
                           :value="(products[row.ProdID] && products[row.ProdID].account ? products[row.ProdID].account : row.Account)" readonly>
                </template>
            </rednax-datatable>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import { formatCurrency, formatNumber, hasPermission } from '@services/Helpers';
import apiClient from '@services/ApiClient';
import Cookies from 'js-cookie';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton.vue';

export default {
    name: 'MultiUpdateProduct',
    components: {
        LimitlessButton,
        vSelect,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    props: {
        mode: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        table_filter: {
            search: '',
            is_struct: 0,
            is_phased_out: 0,
            prod_id: null,
        },
        busy_saving: false,
        show_changes: false,
        per_page: 25,
        products: {},
    }),
    watch: {
        per_page(val) {
            Cookies.set('multi_update_per_page', val, { expires: 365 });
        },
        show_changes(newVal) {
            if (newVal) {
                if (this.mode === 'stock') {
                    this.table_filter.prod_id = Object.keys(this.products).filter((prodId) => this.products[prodId].stock !== '');
                }
                if (this.mode === 'price') {
                    this.table_filter.prod_id = Object.keys(this.products).filter((prodId) => this.products[prodId].prod_net_price !== ''
                            || this.products[prodId].pack_price !== ''
                            || this.products[prodId].pack_mtrl_price !== ''
                            || this.products[prodId].freight_price !== ''
                            || this.products[prodId].direct_sales_price !== ''
                            || this.products[prodId].staff_price !== ''
                            || this.products[prodId].prod_vat !== ''
                            || this.products[prodId].account !== '');
                }
            } else {
                this.table_filter.prod_id = null;
            }
        },
    },
    mounted() {
        if (this.mode === 'price') {
            this.table_filter.is_struct = null;
        }
        const perPage = Cookies.get('multi_update_per_page');
        if (perPage) {
            this.per_page = parseInt(perPage, 10);
        }
    },
    methods: {
        hasPermission,
        formatCurrency,
        formatNumber,
        getRowClass(row) {
            const arr = [];
            if (row.isPhasedOut === 1) {
                arr.push('bg-danger-200');
                arr.push('text-line-through');
            } else if (row.isOutOfStock === 1) {
                arr.push('bg-yellow-200');
            }
            if (row.isStruct === 1) {
                arr.push('font-weight-bold');
            }
            return arr;
        },
        setValue(prodId, type, event) {
            const price = (event.target.value ? parseInt(event.target.value, 10) : '');
            if (!this.products[prodId]) {
                this.$set(this.products, prodId, {});
            }
            this.products[prodId][type] = price;

            const rates = {
                0: 3151,
                6: 3162,
                12: 3160,
                25: 3150,
            };

            if (type === 'prod_vat') {
                this.$swal({
                    text: 'Vill du ändra bokföringskonto till ' + rates[price] + '?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, ändra!',
                    cancelButtonText: 'Nej',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$set(this.products[prodId], 'account', rates[price]);
                    }
                });
            }
        },
        async multiUpdate() {
            if (this.mode === 'price') {
                this.busy_saving = true;
                await apiClient.post('/vue/products/multiupdate', { products: this.products })
                    .then(() => {
                        this.$refs.btnsave.triggerSaved();
                        this.$refs.prodtable.reload();
                        this.products = {};
                    }).catch(() => {
                        this.$refs.btnsave.triggerFailed();
                    }).finally(() => {
                        this.busy_saving = false;
                    });
            } else if (this.mode === 'stock') {
                const { value: comment } = await this.$swal.fire({
                    title: 'Kommentar till saldoändring',
                    input: 'text',
                    inputPlaceholder: 'Kommentar',
                    showCancelButton: true,
                    inputValidator: (value) => new Promise((resolve) => {
                        if (!value) {
                            resolve('Kommentar måste anges!');
                        }
                        resolve();
                    }),
                });
                if (comment) {
                    this.busy_saving = true;
                    const post = {
                        adjustments: [],
                    };
                    Object.keys(this.products).forEach((prodId) => {
                        if (this.products[prodId].stock !== '') {
                            post.adjustments.push({
                                sku: prodId,
                                quantity: '=' + this.products[prodId].stock,
                                comment,
                            });
                        }
                    });
                    await apiClient.post('/vue/products/stock/adjust', post)
                        .then(() => {
                            this.$refs.btnsave.triggerSaved();
                            this.$refs.prodtable.reload();
                            this.products = {};
                        }).catch(() => {
                            this.$refs.btnsave.triggerFailed();
                        }).finally(() => {
                            this.busy_saving = false;
                        });
                }
            }
        },
    },
    computed: {
        table_columns() {
            const arr = [];
            arr.push({
                header: '#',
                data: 'ProdID',
                sortable: true,
            });
            arr.push({
                header: 'Namn (intern)',
                data: 'ProdName',
                sortable: true,
            });
            if (this.mode === 'stock') {
                arr.push({
                    header: 'Lagersaldo',
                    data: 'Stock_today',
                    sortable: true,
                    align_right: true,
                });
                arr.push({
                    header: 'Nytt saldo',
                    data: 'new_stock',
                    sortable: false,
                    class: 'width-150',
                });
                arr.push({
                    header: 'På order',
                    data: 'order',
                    sortable: false,
                    align_right: true,
                    render(row) {
                        return row.Stock_today - row.Stock_future;
                    },
                });
            }
            if (this.mode === 'price') {
                arr.push({
                    header: 'Leverantör',
                    data: 'SupplierName',
                    sortable: true,
                });
                arr.push({
                    header: 'Lev. Artnr.',
                    data: 'ProdSupplierSKU',
                    sortable: true,
                });
                arr.push({
                    header: 'Status',
                    data: 'isPhasedOut',
                    sortable: false,
                });
                arr.push({
                    header: 'Inköp',
                    data: 'new_prod_net_price',
                    sortable: false,
                    class: 'width-100',
                });
                arr.push({
                    header: 'Pack',
                    data: 'new_pack_price',
                    sortable: false,
                    class: 'width-100',
                });
                arr.push({
                    header: 'Packmaterial',
                    data: 'new_pack_mtrl_price',
                    sortable: false,
                    class: 'width-100',
                });
                arr.push({
                    header: 'Frakt',
                    data: 'new_freight_price',
                    sortable: false,
                    class: 'width-100',
                });
                arr.push({
                    header: 'Direktförs.',
                    data: 'new_direct_sales_price',
                    sortable: false,
                    class: 'width-100',
                });
                arr.push({
                    header: 'Personal',
                    data: 'new_staff_price',
                    sortable: false,
                    class: 'width-100',
                });
                arr.push({
                    header: 'Moms',
                    data: 'new_prod_vat',
                    sortable: false,
                    class: 'width-100',
                });
                arr.push({
                    header: 'Konto',
                    data: 'new_account',
                    sortable: false,
                    class: 'width-100',
                });
            }

            return arr;
        },
    },
};

</script>
